module.exports = __webpack_public_path__ + "static/media/Groudon_gaussian2.a0f2970c.png";